<template lang="pug">
.lk-ads(v-if="data" )
	.lk-ads__container
		v-loader(:loading="loading")
		component.lk-ads__title.h1(v-if="data && data.title" :is="data.titleLevel || 'h1'") {{data?.title}}
		template(v-if="data.topFilters" )
			.lk-ads__tabs.tabs-nav-detail(v-for="(filter, index) in data.topFilters" :key="index")
				v-field(:field="filter" v-model="filter.value" @update:model-value="tabChange(filter, $event)")
			.lk-ads__content
			.lk-ads__filter-block
				.lk-ads__filter(v-if="data && data.filters")
					v-filter(ref="filter"
						:filters="data.filters"
						:variables="data.variables"
						@filter-changed="filterChanged"
						@filter-updated="filterUpdated"
						:withButton="false"
						)
				a.lk-ads__filter-btn.btn.btn--primary(v-if="data?.result?.href"
					:href="data?.result?.href") {{ data?.result?.text || 'Поиск' }}
					//-template(#sort="" v-if="data.sort")
					//-template(#view="" v-if="data.view")
			//.lk-ads__sort(v-if="state && state.sort")
			//	v-field.field-no-radio.field--row( v-if="!isXs"
			//		:field="{type: 'table-sort', options: state.sort.options, optionsClassNames: ['field-table-sort__item--big field-table-sort__item--left', 'field-table-sort__item--small', 'field-table-sort__item--small', 'field-table-sort__item--small']}"
			//		v-model="state.sort"
			//		@update:model-value="requestDataLoad"
			//		)
			//	v-field(v-if="isXs" :field="{type: 'select', options: state.sort.options, placeholder: state?.sort?.placeholder }" v-model="state.sort"
			//		@update:model-value="requestDataLoad"
			//	)
			.lk-ads__search
				.lk-ads__search-fields(v-if="data.fields" )
					template(v-for="(filter, index) in data.fields" :key="index")
						v-field.lk-ads__search-field(:field="filter" v-model="filter.value" @update:model-value="setDesiredId")
				.lk-ads__search-buttons(v-if="data.buttons" )
					button.lk-ads__search-button(v-for="(button, index) in data.buttons"
							:key="index"
							:class="button.className"
							:type="button.type"
							@click="submitId")
						| {{ button.text }}
			template(v-if="data.variables?.empty")
				.lk-ads__empty {{ data.variables.empty }}
			template(v-else)
				.lk-ads__bulk(v-if="data.bulk && data?.items?.length")
					.lk-ads__bulk-left
						label.field-checkbox.lk-ads__check.lk-ads__check--all
							input.field-checkbox__input(type="checkbox" :checked="allSelected" @change="toggleSelectAll")
							span.field-checkbox__visual
							span.field-checkbox__text(v-if="data.bulk.selectAllText") {{ data.bulk.selectAllText }}
						button.lk-ads__bulk-action(v-for="(act, i) in data.bulk.actions"
							:key="i"
							:class="{'remove': act.className === 'remove'}"
							:disabled="!selected.length"
							@click="bulkAction(act.action)")
							v-svg-icon.lk-ads__bulk-action-icon(v-if="act.icon" :icon="act.icon")
							| {{ act.text }}
					.lk-ads__bulk-count(v-if="countLabel") {{ countLabel }}
				//- На ПК заголовки колонок выводятся один раз над строками. На мобильных
				//- карточки вертикальные, поэтому подписи остаются внутри каждой карточки.
				.lk-ads__table-header(v-if="tableHeader && !isXs")
					.lk-ads__table-header-check(aria-hidden="true")
					.lk-ads__table-header-ads.advrtsmnt(:class="{'advrtsmnt--no-detail': !tableHeader.detail}")
						.advrtsmnt__top
							.lk-ads__table-header-visual(aria-hidden="true")
							.advrtsmnt__top-name
								.advrtsmnt__header-info(v-if="tableHeader.info") {{tableHeader.info}}
							.advrtsmnt__top-wrap-info.advrtsmnt__top-wrap-info--detail(v-if="tableHeader.detail")
								.advrtsmnt__header-detail {{tableHeader.detail}}
							.advrtsmnt__top-wrap-info.advrtsmnt__top-wrap-info--renewal(v-if="tableHeader.time")
								.advrtsmnt__header-time {{tableHeader.time}}
							.advrtsmnt__top-wrap-info.advrtsmnt__top-wrap-info--date
								.advrtsmnt__header-date(v-if="tableHeader.date") {{tableHeader.date}}
							.advrtsmnt__top-wrap-type
								.advrtsmnt__header-status(v-if="tableHeader.status") {{tableHeader.status}}
							.advrtsmnt__top-wrap-settings
								.advrtsmnt__header-settings(v-if="tableHeader.settings") {{tableHeader.settings}}
				.lk-ads__rows
					template(
						v-for="(item ,index) in data?.items"
						:key="index" )
						.lk-ads__row
							label.field-checkbox.lk-ads__check
								input.field-checkbox__input(type="checkbox" :value="item.id" v-model="selected")
								span.field-checkbox__visual
							v-ads.lk-ads__row-ads(:data-source="item"
								:show-headers="isXs"
								@action="handleClick"
								@navigate="saveReturnState"
							)
		.lk-ads__pagination(v-if="page && page.count > page.limit")
			v-page-nav(:page="page" :limits="limits" @navigate="navigate")

</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
	import controller from "../scripts/controller/controller.js";

	export default {
		mixins: [
			sourceMixin,
			isMobMixin
		],

		data() {
			return {
				data: null,
				page: null,
				desiredId: null,
				selected: [],
				state: {
					filter: null,
				}
			}
		},

		computed: {
			// Набор колонок одинаков для всех элементов ответа ad.list. Берём первый
			// доступный header и выводим его один раз над таблицей на широком экране.
			tableHeader() {
				const item = (this.data?.items || []).find((row) => row?.header);
				return item?.header || null;
			},

			// id объявлений на текущей странице
			pageIds() {
				return (this.data?.items || []).map((item) => item.id);
			},

			// отмечены ли все объявления текущей страницы
			allSelected() {
				const ids = this.pageIds;
				return ids.length > 0 && ids.every((id) => this.selected.includes(id));
			},

			// строка справа: при выбранных — «Выбрано N из M», иначе «Показано N из M»
			countLabel() {
				const bulk = this.data?.bulk;
				if (!bulk) return '';
				if (this.selected.length > 0 && bulk.selectedText) {
					return bulk.selectedText.replace('#COUNT#', this.selected.length);
				}
				return bulk.countText;
			}
		},

		methods: {

			dataSet(data) {
				this.data = data;
				this.page = data.page;
				this.limits = data.limits;
				// сбрасываем выбор при любой перезагрузке списка (смена вкладки/фильтра/страницы/действие)
				this.selected = [];

				if(this.data.modal) {
					controller.openModal({
						...this.data.modal,
					})
				}

				// один раз при первой загрузке: вернуть фильтры/страницу, если пришли из редактирования
				if (!this._returnRestored) {
					this._returnRestored = true;
					this.restoreReturnState();
				}
				// this.state.sort = data.sort;
			},

			// Сохраняем состояние списка (фильтры + страница) перед уходом в редактирование,
			// чтобы после сохранения вернуться на ту же страницу с теми же фильтрами.
			saveReturnState() {
				try {
					const payload = {
						filter: this.state.filter,
						offset: this.page ? this.page.offset : 0,
						limit: this.page ? this.page.limit : null,
						limits: this.limits ? this.limits.value : null
					};
					sessionStorage.setItem('lkAdsReturn:' + window.location.pathname, JSON.stringify(payload));
				} catch (e) {}
			},

			// Восстанавливаем сохранённое состояние при возврате на список и перезапрашиваем данные
			// (сервер вернёт корректные items + фильтры с отметками + активную вкладку).
			restoreReturnState() {
				let payload = null;
				try {
					const key = 'lkAdsReturn:' + window.location.pathname;
					const raw = sessionStorage.getItem(key);
					if (raw) {
						payload = JSON.parse(raw);
						sessionStorage.removeItem(key);
					}
				} catch (e) {}

				if (!payload) return;

				const hasFilter = payload.filter && Object.keys(payload.filter).length > 0;
				if (!hasFilter && !payload.offset) return; // нечего восстанавливать (стартовое состояние)

				if (hasFilter) this.state.filter = payload.filter;
				if (this.page) {
					if (payload.offset != null) this.page.offset = payload.offset;
					if (payload.limit != null) this.page.limit = payload.limit;
				}
				if (this.limits && payload.limits != null) this.limits.value = payload.limits;

				this.requestDataLoad();
			},

			filterChanged(filterValue) {
				this.state.filter = filterValue;
				this.requestDataLoad();
			},


			filterUpdated(filterValue, changedFilters) {
				this.state.filter = filterValue;
				this.changedFilters = changedFilters;
				// update url except markup pages
				if (window.location.pathname.indexOf('/local/') < 0) {
					window.history.replaceState(null, null, this.catalog.remote);
				}
			},

			// sortChanged() {
			// 	this.state.page.offset = 0;
			// 	this.requestDataLoad();
			// },

			handleClick(event) {
				const {action = null, id = null} = event;

				if(!action) return;

				switch (action) {
					case 'make_it_paid' :
						this.reportForChange(action, id);
						break;
					case 'update' :
						this.reportForChange(action, id);
						break;
					case 'deactivate' :
						this.reportForChange(action, id);
						break;
					case 'activate' :
						this.reportForChange(action, id);
						break;
					case 'remove' :
						this.requestRemove(action, id);
						break;
				}
			},

			tabChange(filter, value) {
				this.state.filter = {...this.state.filter, [filter.name]: value}
				this.page.offset = 0;
				this.requestDataLoad();
			},

			setDesiredId(id) {
				this.desiredId = id
			},

			submitId() {
				if(this.desiredId) {
					this.dataLoad({
						url: this.data.remote,
						delay: true,
						data: {
							desiredId: this.desiredId
						}
					});
				}
			},

			reportForChange(action = null, id) {
				if(!action) return;
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						id,
						action
					}
				});
			},

			// «Выбрать все» — только объявления текущей страницы
			toggleSelectAll(event) {
				this.selected = event.target.checked ? [...this.pageIds] : [];
			},

			// Массовое действие над отмеченными объявлениями.
			// Переиспользует те же экшены (deactivate/remove/update), что и одиночные:
			// бэкенд уже принимает массив id.
			bulkAction(action = null) {
				if(!action || !this.selected.length) return;
				const ids = [...this.selected];
				if(action === 'remove') {
					this.requestRemove(action, ids);
				} else {
					this.reportForChange(action, ids);
				}
			},

			requestRemove(action = null, id) {
				if(this.data.modalConfirmRemove) {
					controller.openModal({
						component: {
							...this.data.modalConfirmRemove,
							listeners: {
								'confirm': async () => {
									this.reportForChange(action, id)
								},
							}
						}
					});
				} else {
					this.reportForChange(action, id)
				}
			},

			navigate(page) {
				this.page.offset = page.offset;
				this.page.limit = page.limit;
				this.requestDataLoad();
			},

			requestDataLoad() {
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						page: this.page,
						filter: this.state.filter,
						limits: this.limits.value
					}
				});
			},

		}

	}
</script>
